import {Button as AntdButton, Button, Card, Col, Divider, Row, theme} from 'antd'
import React from 'react'
import {ProjectInfoStatistics} from '../../entities/project'
import 'chart.js/auto'
import {Doughnut} from 'react-chartjs-2'
import {WeatherWidget} from './WeatherWidget'
import './projectPanel.less'
import {Reminders} from '../reminders/Reminders'
import {Link, useNavigate} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {orange} from '@ant-design/colors'

export type ProjectPanelProps = {
  projectStatistics: ProjectInfoStatistics
  plantedPlantsNamesWithId?: {id: number; name: string}[]
}

export function ProjectPanel(props: ProjectPanelProps) {
  const typeLabels = []
  const typeData = []
  Object.entries(props.projectStatistics.plantedPlantsTypes).forEach(([key, value]) => {
    typeLabels.push(key)
    typeData.push(value)
  })
  const attractivenessFactorsLabels = []
  const attractivenessFactorsData = []
  if (props.projectStatistics.plantedPlantsAttractivenessFactors) {
    Object.entries(props.projectStatistics.plantedPlantsAttractivenessFactors).forEach(
      ([key, value]) => {
        attractivenessFactorsLabels.push(key)
        attractivenessFactorsData.push(value)
      }
    )
  }

  const intl = useIntl()

  const navigate = useNavigate()

  return (
    <Card
      variant="borderless"
      style={{
        borderRadius: 12,
        boxShadow: '0 2px 14px rgba(0,0,0,0.06)',
        overflow: 'hidden',
        height: '100%',
      }}
      styles={{
        body: {padding: 0, display: 'grid', minHeight: '200px'},
      }}
      className="project-panel"
    >
      <Link
        to={`/projects/${props.projectStatistics.id}`}
        className="project-panel__name"
        style={{color: orange[5]}}
      >
        {props.projectStatistics.name}
      </Link>
      <div className="info">
        {intl.formatMessage({id: 'totalPlantsInTheProject'})}:{' '}
        {props.projectStatistics.plantedPlantsAmount}
        <div className="doughnut">
          {props.projectStatistics.plantedPlantsAmount === 0 && (
            <div className="project__without-plants">
              <Button
                ghost
                danger
                id="button-no-todos"
                onClick={() => {
                  navigate(`/projects/${props.projectStatistics.id}/plants/new`)
                }}
              >
                {intl.formatMessage({id: 'createTheFirstPlantInTheProject'})}
              </Button>
            </div>
          )}
          {typeData.length !== 0 && (
            <div>
              <Doughnut
                options={{
                  responsive: true,
                  plugins: {
                    legend: {
                      display: false,
                    },
                  },
                }}
                data={{
                  labels: typeLabels,
                  datasets: [
                    {
                      data: typeData,
                      borderWidth: 1,
                      backgroundColor: [
                        'rgb(160, 122, 108)',
                        'rgb(245, 242, 83)',
                        'rgb(245, 129, 83)',
                        'rgb(53, 171, 151)',
                        'rgb(154, 83, 245)',
                        'rgb(223, 206, 198)',
                        'rgb(215, 214, 153)',
                        'rgb(215, 171, 153)',
                        'rgb(210, 226, 222)',
                        'rgb(182,155,218)',
                      ],
                    },
                  ],
                }}
              />
              {/* <span>{intl.formatMessage({id: 'plantTypeDistributionDiagram'})}</span> */}
            </div>
          )}
        </div>
      </div>
      {/* <Icon icon={Icons.faDrawPolygon} /> */}

      {/* {props.projectStatistics.plantedPlantsAttractivenessFactors && (
        <div className="chart">
          <Chart
            type={'bar'}
            data={{
              labels: attractivenessFactorsLabels,
              datasets: [
                {
                  data: attractivenessFactorsData,
                  borderWidth: 1,
                },
              ],
            }}
          />
        </div>
      )} */}

      {/* <div className="project-reminders">
        {props.projectStatistics.mainToDos && props.projectStatistics.mainToDos.length !== 0 && (
          <div className="project-reminders__with-todo">
            <Reminders
              todos={props.projectStatistics.mainToDos}
              plantedPlantsNamesWithId={props.plantedPlantsNamesWithId}
            ></Reminders>
          </div>
        )}
        {(!props.projectStatistics.mainToDos || props.projectStatistics.mainToDos.length === 0) && (
          <div className="project-reminders__without-todo">
            <Button
              ghost
              danger
              id="button-no-todos"
              onClick={() => {
                navigate(`/todos`)
              }}
            >
              {intl.formatMessage({
                id: 'createATaskListAssociatedWithTheProjectAndEnterTheFirstTask',
              })}
            </Button>
          </div>
        )}
      </div> */}
      <div className="weather">
        <WeatherWidget
          weather={props.projectStatistics.weather}
          projectId={props.projectStatistics.id}
        />
      </div>
    </Card>
  )
}
